import { render, staticRenderFns } from "./Rateios.vue?vue&type=template&id=472e205a&"
import script from "./Rateios.vue?vue&type=script&lang=js&"
export * from "./Rateios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports